import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.OVERVIEW}.${BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.MARKET_CUSTOMERS}` as const;

export const MARKET_AND_CUSTOMER_NAMES = {
  // TARGET_AUDIENCE: 'targetAudience',
  // TARGET_CHANNELS: 'targetChannels',
  // MAIN_COMPETITORS: 'mainCompetitors',
} as const;

export interface IMarketAndCustomersOverviewForm {
  // [MARKET_AND_CUSTOMER_NAMES.TARGET_AUDIENCE]: string;
  // [MARKET_AND_CUSTOMER_NAMES.TARGET_CHANNELS]: string;
  // [MARKET_AND_CUSTOMER_NAMES.MAIN_COMPETITORS]: string;
}

export const overviewMarketAndCustomersInitialValues: IMarketAndCustomersOverviewForm = {
  // [MARKET_AND_CUSTOMER_NAMES.TARGET_AUDIENCE]: '',
  // [MARKET_AND_CUSTOMER_NAMES.TARGET_CHANNELS]: '',
  // [MARKET_AND_CUSTOMER_NAMES.MAIN_COMPETITORS]: '',
};
